export default "__VITE_ASSET__661cf9e2__"